export enum ButtonContentEnum {
  LABEL = 'label',
  ICON = 'icon'
}
